// 検索条件をブラウザバック時に復元するための sessionStorage 汎用ユーティリティ。
// state が null の場合は該当キーを削除する（クリア用途）。
export function persistSearchSessionState<T>(storageKey: string, state: T | null): void {
  if (state === null) {
    sessionStorage.removeItem(storageKey);
    return;
  }
  sessionStorage.setItem(storageKey, JSON.stringify(state));
}

export function readSearchSessionState<T>(storageKey: string): T | null {
  const raw = sessionStorage.getItem(storageKey);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    sessionStorage.removeItem(storageKey);
    return null;
  }
}
